/* Topo da home como showroom dos lançamentos: gira entre as bikes a cada N s ou no clique da régua.
   Cada bike tem um <video> próprio (computador 16:9 / celular 4:5); o arquivo só é carregado quando a bike entra na vez
   (e o seguinte é pré-carregado), pra não repetir o peso de 43 MB da home no celular. Sem MutationObserver. */
(function () {
  'use strict';
  var DESKTOP = window.matchMedia('(min-width: 750px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function LaunchHero(root) {
    this.root = root;
    this.videos = Array.prototype.slice.call(root.querySelectorAll('[data-lh-video]'));
    this.copies = Array.prototype.slice.call(root.querySelectorAll('[data-lh-copy]'));
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[data-lh-tab]'));
    this.counter = root.querySelector('[data-lh-counter]');
    this.name = root.querySelector('[data-lh-name]');
    this.interval = Math.max(4, parseInt(root.getAttribute('data-lh-interval'), 10) || 8) * 1000;
    this.i = 0; this.timer = null; this.paused = false; this.muted = true; this.visible = true;
    if (!this.videos.length) return;
    this.bind();
    this.go(0, true);
  }

  LaunchHero.prototype.src = function (v) {
    return DESKTOP.matches ? (v.getAttribute('data-pc') || v.getAttribute('data-cel')) : (v.getAttribute('data-cel') || v.getAttribute('data-pc'));
  };

  LaunchHero.prototype.load = function (idx) {
    var v = this.videos[idx]; if (!v) return;
    var want = this.src(v);
    if (want && v.getAttribute('src') !== want) { v.setAttribute('src', want); v.load(); }
  };

  LaunchHero.prototype.go = function (idx, first) {
    var n = this.videos.length; idx = ((idx % n) + n) % n;
    var self = this, prev = this.videos[this.i];
    if (!first && prev) { prev.classList.remove('is-on'); try { prev.pause(); } catch (e) {} }
    this.i = idx;
    var v = this.videos[idx];
    this.load(idx); this.load(idx + 1 < n ? idx + 1 : 0);
    v.muted = this.muted; v.classList.add('is-on');
    if (!this.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    this.copies.forEach(function (c, k) { c.hidden = k !== idx; });
    this.tabs.forEach(function (t, k) {
      var on = k === idx; t.classList.toggle('is-on', on); t.classList.toggle('is-done', k < idx); t.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) { var bar = t.querySelector('.lh__bar'); if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; } }
    });
    if (this.counter) this.counter.textContent = (idx + 1) + ' of ' + n;
    if (this.name) this.name.textContent = v.getAttribute('data-name') || '';
    this.schedule();
  };

  LaunchHero.prototype.schedule = function () {
    var self = this; clearTimeout(this.timer);
    if (this.paused || !this.visible || REDUCED.matches || this.videos.length < 2) return;
    this.timer = setTimeout(function () { self.go(self.i + 1); }, this.interval);
  };

  LaunchHero.prototype.setPaused = function (on) {
    this.paused = on; this.root.classList.toggle('is-paused', on);
    var v = this.videos[this.i];
    if (on) { clearTimeout(this.timer); try { v.pause(); } catch (e) {} }
    else { var p = v.play(); if (p && p.catch) p.catch(function () {}); this.schedule(); }
    var b = this.root.querySelector('[data-lh-pause]'); if (b) { b.classList.toggle('is-paused', on); b.setAttribute('aria-label', on ? 'Resume' : 'Pause'); }
  };

  LaunchHero.prototype.setMuted = function (on) {
    this.muted = on; this.videos.forEach(function (v) { v.muted = on; });
    var b = this.root.querySelector('[data-lh-mute]'); if (b) { b.classList.toggle('is-muted', on); b.setAttribute('aria-label', on ? 'Unmute' : 'Mute'); }
  };

  LaunchHero.prototype.bind = function () {
    var self = this;
    this.tabs.forEach(function (t, k) { t.addEventListener('click', function () { self.go(k); }); });
    var pause = this.root.querySelector('[data-lh-pause]'); if (pause) pause.addEventListener('click', function () { self.setPaused(!self.paused); });
    var mute = this.root.querySelector('[data-lh-mute]'); if (mute) mute.addEventListener('click', function () { self.setMuted(!self.muted); });
    this.setMuted(true);
    // vídeo mais curto que o intervalo: deixa em loop até a troca
    this.videos.forEach(function (v) { v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) { clearTimeout(self.timer); try { self.videos[self.i].pause(); } catch (e) {} } else if (!self.paused) { var p = self.videos[self.i].play(); if (p && p.catch) p.catch(function () {}); self.schedule(); } });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { self.visible = e.isIntersecting; if (!e.isIntersecting) { clearTimeout(self.timer); try { self.videos[self.i].pause(); } catch (x) {} } else if (!self.paused) { var p = self.videos[self.i].play(); if (p && p.catch) p.catch(function () {}); self.schedule(); } });
      }, { threshold: 0.25 }).observe(this.root);
    }
    var onMedia = function () { self.load(self.i); if (!self.paused) { var p = self.videos[self.i].play(); if (p && p.catch) p.catch(function () {}); } };
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', onMedia); else if (DESKTOP.addListener) DESKTOP.addListener(onMedia);
  };

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-launch-hero]'), function (el) {
      if (el.__lh) return; el.__lh = new LaunchHero(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
